import { useDispatch } from 'react-redux';
import { addItem } from '../services/cartSlice';
import { useNavigate } from 'react-router-dom';

const Item = ({ image, title, type, price, id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAddToCart = (e) => {
    e.stopPropagation(); // Prevent navigation when clicking the add to cart button
    dispatch(addItem({ id, name: title, price, photos: [image] }));
  };

  return (
    <div 
      onClick={() => navigate(`/product/${id}`)}
      className="flex flex-col items-center p-4 w-full max-w-[350px] bg-base-300 shadow-sm hover:shadow-md transition-transform hover:-translate-y-1 cursor-pointer rounded-md shadow-md"
    >
      <img 
        src={image} 
        alt={title} 
        className="w-[300px] h-[300px] object-cover rounded-md mb-4"
      />
      <h2 className="text-lg text-center mb-4 max-w-[200px] h-[50px] custom-font-text">{title}</h2>
      <h4 className="text-center max-w-[200px] custom-font-text text-[10px]">{type}</h4>
      <div className="text-lg mb-2">${price}</div>
      <button 
        onClick={handleAddToCart}
        className="bg-transparent border-2 border-accent text-accent px-8 py-2 rounded-full hover:bg-accent hover:bg-opacity-40 transition-all duration-300 font-bold-md"
      >
        ADD TO CART
      </button>
    </div>
  );
};

export default Item; 